import React from "react";
import useTranslate from "../../../modules/local/useTranslate";
import _ from 'lodash'
import {Image} from "antd";
import {ImagePlaceholder} from "../../../conts/imageBase64";
import {AnnouncementTypes} from "../../AppLocals/Organization/consts/AnnouncementTypes";
import {BsMegaphoneFill} from "react-icons/bs";
import {
    AnnouncementLinkButton,
    AnnouncementMessage,
    AnnouncementMetaLine,
    AnnouncementTypeBadge,
    renderAnnouncementTimeSection,
} from "../../../components/Feed/AnnouncementCardHelpers";

// Per-type color config — inline styles only, no Tailwind color classes
// so no purge/JIT issues
export const TYPE_COLORS = {
    WEDDING: {
        bg: '#FFF0F3',
        iconBg: '#F43F5E',
        accent: '#E11D48',
        label: '#BE123C',
        timeBg: '#FFE4E8',
        timeText: '#9F1239',
        border: '#FECDD3',
    },
    BANNS_OF_MARRIAGE: {
        bg: '#FFF0F6',
        iconBg: '#EC4899',
        accent: '#DB2777',
        label: '#9D174D',
        timeBg: '#FCE7F3',
        timeText: '#831843',
        border: '#FBCFE8',
    },
    BAPTISM: {
        bg: '#EFF6FF',
        iconBg: '#3B82F6',
        accent: '#2563EB',
        label: '#1D4ED8',
        timeBg: '#DBEAFE',
        timeText: '#1E40AF',
        border: '#BFDBFE',
    },
    OBITUARY: {
        bg: '#F8FAFC',
        iconBg: '#475569',
        accent: '#334155',
        label: '#1E293B',
        timeBg: '#F1F5F9',
        timeText: '#334155',
        border: '#CBD5E1',
    },
    FINANCIAL_AID: {
        bg: '#ECFDF5',
        iconBg: '#10B981',
        accent: '#059669',
        label: '#065F46',
        timeBg: '#D1FAE5',
        timeText: '#064E3B',
        border: '#A7F3D0',
    },
    PATRON_FEAST: {
        bg: '#FFFBEB',
        iconBg: '#F59E0B',
        accent: '#D97706',
        label: '#92400E',
        timeBg: '#FEF3C7',
        timeText: '#78350F',
        border: '#FDE68A',
    },
    ANNOUNCEMENT: {
        bg: '#EFF6FF',
        iconBg: '#6366F1',
        accent: '#4F46E5',
        label: '#3730A3',
        timeBg: '#E0E7FF',
        timeText: '#312E81',
        border: '#C7D2FE',
    },
    DEFAULT: {
        bg: '#F8FAFC',
        iconBg: '#94A3B8',
        accent: '#64748B',
        label: '#475569',
        timeBg: '#F1F5F9',
        timeText: '#334155',
        border: '#E2E8F0',
    },
}

export const OrganizationAnnouncementItem = ({item}) => {

    const t = useTranslate()
    const {
        title, type_label, type_code, photo,
        content,
        time_close, time_open, shared_url,
    } = item ?? {}

    const colors = TYPE_COLORS[type_code] || TYPE_COLORS.DEFAULT
    // Danh sách icon theo type_code (AnnouncementTypes) chỉ có nghĩa cho owner_type=organization
    // (WEDDING/BAPTISM...) - group/course dùng lookup động riêng (type_code do admin tự đặt tên,
    // không có set cố định) nên luôn rơi về icon loa mặc định, KHÔNG đoán icon theo từ khóa.
    const typeIcon = _.find(AnnouncementTypes, {value: type_code || item?.type})?.icon
        || <BsMegaphoneFill/>

    return (
        <div
            className=""
            style={{
                overflow: 'hidden',
                // Nền trắng + viền trung tính bất kể loại (trước đây nền tint colors.bg theo loại) -
                // bạn góp ý "nhiều khối màu quá": nền card màu là mảng fill lớn nhất, chồng dưới badge
                // + metadata + khối message + khối thời gian. Màu theo loại giờ chỉ còn ở icon badge.
                border: '1px solid #E2E8F0',
                background: '#fff',
                borderRadius: '0.75rem',
            }}>
            {/* Photo with overlay tag */}
            {photo ? (
                <div style={{position: 'relative'}}>
                    <Image
                        src={photo}
                        fallback={ImagePlaceholder}
                        style={{
                            display: 'block',
                            width: '100%',
                            height: 'auto'
                        }}
                        wrapperClassName="w-full background-200"
                        preview={false}
                    />
                    <div style={{position: 'absolute', top: 12, left: 12}}>
                        <AnnouncementTypeBadge icon={typeIcon} label={type_label} colors={colors} overlay/>
                    </div>
                </div>
            ) : type_label && (
                <div style={{padding: '0.75rem 0.75rem 0'}}>
                    <AnnouncementTypeBadge icon={typeIcon} label={type_label} colors={colors}/>
                </div>
            )}

            {/* Body */}
            <div className="p-3 flex flex-col gap-3">
                <AnnouncementMetaLine item={item} t={t}/>
                <div className="font-bold text-base leading-snug text-color-000">
                    {title}
                </div>
                <AnnouncementMessage content={content} colors={colors}/>
                <AnnouncementLinkButton shared_url={shared_url} colors={colors} t={t}/>

                {(time_open || time_close) && renderAnnouncementTimeSection({time_open, time_close, t})}
            </div>
        </div>
    )
}